import { TableRow, TableCell, Typography, Button, Checkbox, Box } from '@mui/material';

export default function AppSectionListModalTableRow({ row, rowNumber, selected, onSelectRow, selectAppSectionHandler }) {
  const { ApplicationSectionLable, ApplicationSectionKeyOrder } = row;

  return (
    <TableRow hover selected={selected}>
      <TableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell className="fixed-table-cell" align="center">
        <Typography variant="body1">{ApplicationSectionLable}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{ApplicationSectionKeyOrder}</Typography>
      </TableCell>

      <TableCell align="center">
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          <Button color="warning" variant="contained" onClick={() => selectAppSectionHandler(row)}>
            انتخاب
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
}
